module.exports = __webpack_public_path__ + "img/35.c71dda72.jpg";